import { createSlice } from '@reduxjs/toolkit';

const loginState = createSlice({
  name: 'loggedInUser',
  initialState: {
    // name: 'LOGGED_IN',
    // forename: 'INITIAL STATE SET (loginState)',
    // surname: 'INITIAL STATE SET (loginState)'
  },
  reducers: {
    setLoggedInUser(state, action) {
      return {
        ...action.payload
      }
    }
  }
});

export const { setLoggedInUser } = loginState.actions;
export default loginState.reducer;